import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Page } from 'tesseract.js';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) { }


  editUser(id: any, Data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/update/user/${id}`, Data);
  }

  getAllUsers(): Observable<any> {
    return this.http.get(environment.Server_URL + '/index/users');
  }
  deleteUser(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/delete/user/' + id);
  }


}
